import { defineMessages } from 'react-intl'

const scope = 'app.containers.Users'

export default defineMessages({
  actions: {
    create: {
      id: `${scope}.actions.create`,
      defaultMessage: 'Create a new {type}',
    },
    edit: {
      id: `${scope}.actions.edit`,
      defaultMessage: 'Edit',
    },
    delete: {
      id: `${scope}.actions.delete`,
      defaultMessage: 'Delete',
    },
    createByCSV: {
      id: `${scope}.actions.createByCSV`,
      defaultMessage: 'Create {type}s CSV',
    },
    example: {
      id: `${scope}.actions.example`,
      defaultMessage: 'Download CSV example',
    },
    exportCSV: {
      id: `${scope}.actions.exportCSV`,
      defaultMessage: 'Export CSV',
    },
  },
})
